"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const throttle_debounce_1 = require("throttle-debounce");
const ApiUtil_1 = __importDefault(require("../util/ApiUtil"));
const GET_ADDRESS_SUGGESTION_REL = 'address/address-suggest';
const GET_ADDRESS_BY_ID_REL = 'address/address';
class ContactAddressStore {
    constructor(rootStore) {
        Object.defineProperty(this, "address", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "room", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "canInvalidateAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "addressAutocompleteItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "roomAutocompleteItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "isAddressPrecised", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "selectedAddressItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "addressValueOnSelect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "addressValueOnChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "throttledFetchAddressAutocompleteOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setAddressAutocompleteRepresentation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (!this.contactInfoStore.isContactAddressInitialized) {
                    return;
                }
                const address = this.contactInfoStore.contactAddress.address;
                const addressRepresentation = this.getLoadedAddressText(address);
                this.loadRoomsOptionsOnFormInit(addressRepresentation, address);
                if (address.room) {
                    this.onRoomAutocompleteChange(address.room);
                }
            }
        });
        Object.defineProperty(this, "sentenceCase", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (str) => {
                const s = str ? str : '';
                return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
            }
        });
        Object.defineProperty(this, "addSeparator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (str, separator = ',') => (str ? str + separator : '')
        });
        Object.defineProperty(this, "getLoadedAddressText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (address) => {
                const cs = this.sentenceCase;
                const sep = this.addSeparator;
                const { street, building, municipality, postalCode, city, region } = address;
                const streetAndBuilding = `${cs(street)} ${cs(building)}`.trim();
                const indexAndCity = `${cs(postalCode)} ${cs(city)}`.trim();
                return `${sep(streetAndBuilding)} ${sep(municipality)} ${sep(indexAndCity)} ${cs(region)}`.trim();
            }
        });
        Object.defineProperty(this, "changeAddressText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (term) => {
                this.addressValueOnChange = term;
                this.throttledFetchAddressAutocompleteOptions(term);
            }
        });
        Object.defineProperty(this, "onRoomAutocompleteChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (value) => {
                await this.selectRoom(value);
            }
        });
        Object.defineProperty(this, "onRoomAutocompleteSelection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (value) => {
                await this.selectRoom(value);
            }
        });
        Object.defineProperty(this, "selectRoom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (value) => {
                const isNotPrecise = this.isAddressNotPrecise;
                this.room = value;
                const selectedRoom = this.findRoom(value);
                this.contactInfoStore.resetOldAddressReferences();
                this.isAddressPrecised = false;
                if (selectedRoom) {
                    this.contactInfoStore.setRoomId(selectedRoom.data.room_id);
                    await this.checkRoomWithDifferentAddress(value, isNotPrecise);
                }
            }
        });
        Object.defineProperty(this, "checkRoomWithDifferentAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (roomLabel, isAddressNotPrecise) => {
                const selectedRoom = this.findRoom(roomLabel);
                if (this.isRoomWithDifferentAddress(selectedRoom)) {
                    const address = await this.getAddressById(selectedRoom.data.room_address_id);
                    this.addressAutocompleteItems = [{ data: address.data, label: address.data.label2 }];
                    this.selectedAddressItem = this.addressAutocompleteItems[0].data;
                    this.onAddressAutocompleteSelection(this.addressAutocompleteItems[0].label);
                    this.room = roomLabel;
                }
                this.isAddressPrecised = this.hasRooms && isAddressNotPrecise;
            }
        });
        Object.defineProperty(this, "findRoom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (roomLabel) => {
                const items = this.roomAutocompleteItems;
                if (items) {
                    return items.find((i) => i.label === roomLabel);
                }
                return undefined;
            }
        });
        Object.defineProperty(this, "parseRooms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (address) => {
                return address && address.rooms ? JSON.parse(address.rooms[0]) : [];
            }
        });
        Object.defineProperty(this, "findAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (address) => {
                const result = this.addressAutocompleteItems.find((i) => i.data.label === address || i.data.label2 === address);
                if (result) {
                    return result.data;
                }
                return undefined;
            }
        });
        Object.defineProperty(this, "findAddressByIds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (addressId, buildingId, roomId) => {
                let result = this.addressAutocompleteItems.find((i) => parseInt(i.data.id, 10) === addressId || parseInt(i.data.building_id, 10) === buildingId);
                if (!result && roomId) {
                    result = this.addressAutocompleteItems.find((i) => JSON.parse(i.data.rooms[0]).find((r) => parseInt(r.room_id, 10) === roomId));
                }
                if (result) {
                    return result.data;
                }
                return undefined;
            }
        });
        Object.defineProperty(this, "isRoomWithDifferentAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (selectedRoom) => {
                return (selectedRoom &&
                    selectedRoom.data &&
                    selectedRoom.data.room_address_id &&
                    this.selectedAddressItem &&
                    selectedRoom.data.room_address_id !== this.selectedAddressItem.id);
            }
        });
        Object.defineProperty(this, "resetRoomAndItsOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.room = '';
                this.roomAutocompleteItems = [];
            }
        });
        Object.defineProperty(this, "onAddressAutocompleteSelection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.addressValueOnSelect = value;
                this.selectedAddressItem = this.findAddress(value);
                this.isAddressPrecised = false;
                this.resetRoomAndItsOptions();
                const cs = this.contactInfoStore;
                const rooms = this.parseRooms(this.selectedAddressItem);
                cs.resetOldAddressReferences();
                cs.setAddressIsDirty();
                this.setAddress(value);
                if (this.selectedAddressItem.building_id && this.hasRooms(rooms)) {
                    cs.setBuildingId(this.selectedAddressItem.building_id);
                    this.modifyRoomAutocompleteDataBasedOnAddressSelection(rooms);
                }
                else {
                    cs.setRegistryId(this.selectedAddressItem.id);
                }
            }
        });
        Object.defineProperty(this, "hasRooms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rooms) => {
                return rooms && rooms.length > 0;
            }
        });
        Object.defineProperty(this, "setAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.address = value;
                this.canInvalidateAddress = !!value;
            }
        });
        Object.defineProperty(this, "modifyRoomAutocompleteDataBasedOnAddressSelection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rooms) => {
                this.roomAutocompleteItems = rooms
                    .map((r) => {
                    return { label: r.room_name, data: r };
                })
                    .sort((a, b) => {
                    const lengthDiff = a.label.length - b.label.length;
                    if (lengthDiff === 0) {
                        return a.label.localeCompare(b.label);
                    }
                    else {
                        return lengthDiff;
                    }
                });
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.ssoStore = rootStore.ssoStore;
        this.contactInfoStore = rootStore.contactInfoStore;
        this.throttledFetchAddressAutocompleteOptions = (0, throttle_debounce_1.throttle)(500, async (term) => {
            await this.fetchAddressAutocompleteOptions(term);
        });
        (0, mobx_1.reaction)(() => this.contactInfoStore.isContactAddressInitialized, this.setAddressAutocompleteRepresentation);
    }
    getAddressSuggestion(term) {
        return ApiUtil_1.default.get(GET_ADDRESS_SUGGESTION_REL, {
            params: { term }
        });
    }
    getAddressById(addressId) {
        return ApiUtil_1.default.get(GET_ADDRESS_BY_ID_REL, {
            params: { addressId }
        });
    }
    get isAddressValid() {
        return !!this.address;
    }
    get isRoomValid() {
        const r = this.room;
        return !r || !!(this.isAddressValid && r && this.findRoom(r));
    }
    get isAddressFormValid() {
        return this.isRoomValid && this.isAddressValid;
    }
    get isAddressNotPrecise() {
        return this.selectedAddressItem && this.selectedAddressItem.label2 !== this.selectedAddressItem.label && (!this.room || this.room.length === 0);
    }
    async fetchAddressAutocompleteOptions(term) {
        if (term) {
            const query = await this.getAddressSuggestion(term);
            this.addressAutocompleteItems = query.data.addresses.map((address) => {
                return { data: address, label: address.label2 };
            });
        }
        if (this.addressValueOnChange !== this.addressValueOnSelect) {
            this.setAddress('');
        }
    }
    async loadRoomsOptionsOnFormInit(addressRepresentation, address) {
        await this.fetchAddressAutocompleteOptions(addressRepresentation);
        if (this.addressAutocompleteItems.length === 0) {
            return;
        }
        const { roomRegistryId, buildingRegistryId, addressRegistryId } = address;
        const fetchedAddress = this.findAddressByIds(addressRegistryId, buildingRegistryId, roomRegistryId);
        this.selectedAddressItem = fetchedAddress;
        let label;
        const addressHasExactLocation = roomRegistryId || (buildingRegistryId && addressRegistryId);
        if (fetchedAddress) {
            label = this.selectedAddressItem.label2;
        }
        else {
            if (addressHasExactLocation) {
                label = addressRepresentation;
            }
            this.selectedAddressItem = this.addressAutocompleteItems[0].data;
        }
        this.modifyRoomAutocompleteDataBasedOnAddressSelection(this.parseRooms(this.selectedAddressItem));
        this.setAddress(label);
    }
}
__decorate([
    mobx_1.observable
], ContactAddressStore.prototype, "address", void 0);
__decorate([
    mobx_1.observable
], ContactAddressStore.prototype, "room", void 0);
__decorate([
    mobx_1.observable
], ContactAddressStore.prototype, "canInvalidateAddress", void 0);
__decorate([
    mobx_1.observable
], ContactAddressStore.prototype, "addressAutocompleteItems", void 0);
__decorate([
    mobx_1.observable
], ContactAddressStore.prototype, "roomAutocompleteItems", void 0);
__decorate([
    mobx_1.observable
], ContactAddressStore.prototype, "isAddressPrecised", void 0);
__decorate([
    mobx_1.observable
], ContactAddressStore.prototype, "selectedAddressItem", void 0);
__decorate([
    mobx_1.observable
], ContactAddressStore.prototype, "addressValueOnSelect", void 0);
__decorate([
    mobx_1.observable
], ContactAddressStore.prototype, "addressValueOnChange", void 0);
__decorate([
    mobx_1.computed
], ContactAddressStore.prototype, "isAddressValid", null);
__decorate([
    mobx_1.computed
], ContactAddressStore.prototype, "isRoomValid", null);
__decorate([
    mobx_1.computed
], ContactAddressStore.prototype, "isAddressFormValid", null);
__decorate([
    mobx_1.computed
], ContactAddressStore.prototype, "isAddressNotPrecise", null);
exports.default = ContactAddressStore;
